<template>
  <div>
    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      max-items="100"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div
        class="mt-6 flex items-center justify-between px-6"
        v-if="productSpec"
      >
        <div class="flex items-center">
          <img
            v-if="productSpec.imageUrl && productSpec.imageUrl !== ''"
            width="40"
            :src="productSpec.imageUrl"
            class="mr-4"
          />
          <img v-else width="40" :src="ProductIcon" class="mr-4" />
          <div>
            <h4>Product recipe</h4>
            <small v-if="orgProductSpec"
              >Created by {{ orgProductSpec.createdBy.username }}</small
            >
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <p class="mb-3 font-bold">Details</p>

          <vs-row>
            <vs-col vs-w="6">
              <div>
                <vs-row class="mb-2">
                  <h3 class="spec-name">{{ productSpec.name }}</h3>
                </vs-row>
                <img
                  :src="productSpec.imageUrl"
                  height="140px"
                  class="rounded-lg"
                />
              </div>
            </vs-col>
            <vs-col vs-w="6" v-if="orgProductSpec">
              <div>
                <vs-row class="mb-1 text-sm">
                  <span>Created by</span>
                </vs-row>
                <vs-row>
                  <code
                    >{{ orgProductSpec.createdBy.username }} at
                    {{ orgProductSpec.createdAt | formatDate }}</code
                  >
                </vs-row>
              </div>
              <div v-if="orgProductSpec.updatedBy" class="mt-2">
                <vs-row class="mb-1 text-sm">
                  <span>Updated by</span>
                </vs-row>
                <vs-row>
                  <code
                    >{{ orgProductSpec.updatedBy.username }} at
                    {{ orgProductSpec.updatedAt | formatDate }}</code
                  >
                </vs-row>
              </div>
            </vs-col>
          </vs-row>

          <vs-divider />

          <p class="mb-3 font-bold">Recipe</p>

          <div class="recipe-table data-list-list-view">
            <vs-table :data="mappedItems">
              <template slot="thead">
                <vs-th>Type</vs-th>
                <vs-th sort-key="name">Name</vs-th>
                <vs-th sort-key="amount">Amount</vs-th>
                <vs-th></vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                    <vs-td>
                      <div
                        class="
                          product-name
                          font-medium
                          truncate
                          flex flex-row
                          items-center
                        "
                      >
                        <img
                          v-if="tr.type == 'product'"
                          width="40"
                          :src="ProductIcon"
                        />
                        <img v-else width="40" :src="CategoryIcon" />
                        <span class="ml-2">{{
                          tr.type == "product" ? "Product" : "Category"
                        }}</span>
                      </div>
                    </vs-td>
                    <vs-td>
                      <div>
                        {{ tr.name }}
                      </div>
                    </vs-td>
                    <vs-td>
                      <div class="flex items-center">
                        <div class="flex inline-block">
                          {{ tr.amount }} {{ tr.unit }}
                        </div>
                      </div>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap"> </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>

          <vs-divider />

          <p class="mb-3 font-bold">Recipe info</p>

          <div class="flex space-between mt-5">
            <vs-col vs-w="6" class="ml-5">
              <vs-col vs-w="6">
                <b>Number of items in recipe: </b>
              </vs-col>
              <vs-col vs-w="6">
                <span>{{ mappedItems.length }}</span>
              </vs-col>
              <vs-col vs-w="6">
                <b>Total recipe amount: </b>
              </vs-col>
              <vs-col vs-w="6">
                <span>{{ totalAmount }} cl</span>
              </vs-col>

              <div></div>
            </vs-col>
            <vs-col vs-w="6">
              <div id="chart">
                <VueApexCharts
                  type="pie"
                  width="400"
                  :options="chartOptions"
                  :series="series"
                ></VueApexCharts>
              </div>
            </vs-col>
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click="create"
          :disabled="!isFormValid"
          v-if="isNew"
        >
          Create
        </vs-button>
        <vs-button class="mr-6" @click="cancel"> Go back </vs-button>
        <!-- <vs-button v-if="!isNew" color="danger" @click="confirmDelete">
          Delete</vs-button
        > -->
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/product-icon.png";
import CategoryIcon from "@/assets/images/storage_icon.png";
import { mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    VuePerfectScrollbar,
    VueApexCharts,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,
      CategoryIcon,

      isActive: false,
      isLoading: true,

      isNew: false,
      productSpec: null,
      orgProductSpec: null,
    };
  },
  computed: {
    ...mapGetters({
      stockProducts: "stockProducts/stockProducts",
      productCategories: "productCategories/productCategories",
    }),
    chartOptions() {
      let labels = this.mappedItems.map((item) => {
        // Cut name length to a maximum of 15
        let name = item.name;
        if (name.length > 15) {
          name = name.substring(0, 15) + "...";
        }
        return name;
      });

      return {
        chart: {
          width: 400,
          type: "pie",
        },
        colors: [
          "#17312D",
          "#E6BD71",
          "#4ecdc4",
          "#ff6b6b",
          "#7272ab",
          "#dddbf1",
          "#592941",
          "#52b788",
        ],
        labels,
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
    series() {
      // TODO unit calculation
      return this.mappedItems.map((item) => {
        return parseFloat(item.amount);
      });
    },
    totalAmount() {
      // TODO unit calculation
      return this.mappedItems.reduce((acc, item) => {
        return acc + parseFloat(item.amount);
      }, 0);
    },
    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    mappedItems() {
      if (!this.productSpec) return [];

      let products = this.productSpec.stockProductSpecItems.map((item) => {
        return {
          type: "product",
          id: item.stockProductId.id,
          name: item.name,
          amount: item.quantity.amount,
          unit: item.quantity.unit,
        };
      });

      let categories = this.productSpec.productCategorySpecItems.map((item) => {
        return {
          type: "category",
          id: item.productCategoryId.id,
          name: item.name,
          amount: item.quantity.amount,
          unit: item.quantity.unit,
        };
      });

      return [...products, ...categories];
    },
  },
  methods: {
    async show(productSpecId) {
      this.isActive = true;
      this.isLoading = true;
      this.isNew = false;

      var result = await this.$store.dispatch(
        "productSpecs/getProductSpec",
        productSpecId
      );

      this.orgProductSpec = result;
      this.productSpec = {
        name: result.name,
        imageUrl: result.imageUrl,
        stockProductSpecItems: result.stockProductSpecItems,
        productCategorySpecItems: result.productCategorySpecItems,
      };

      console.log("Got product spec", this.productSpec);
      this.isLoading = false;
    },

    async cancel() {
      this.productSpec = null;
      this.isActive = false;
    },
  },
};
</script>

<style lang="scss">
.recipe-table {
  .vs-table--thead tr {
    color: white;
  }

  .vs-con-tbody {
    background-color: rgba(var(--vs-primary)) !important;
    border-radius: 8px;
  }
}
</style>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 920px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.spec-name {
  font-family: HelNeue;
  letter-spacing: 0.05em;
}
</style>